import { ReactElement, useEffect} from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { isCountryBlacklistedSelector } from 'store/entities/config/selectors';
import { getUserGeolocation } from 'store/entities/config/thunks';
import { isMainnet } from 'utils';

import { CountryBlacklistRow } from 'components';

import './WithCountryBlacklist.scss';

const WithCountryBlacklist = ({ children }: { children: ReactElement }) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const isGeofencingDisabled = searchParams.get('maintenance') === 'false';

  const isForbiddenCountry = useSelector(isCountryBlacklistedSelector);

  useEffect(() => {
    if (isMainnet() && !isGeofencingDisabled) {
      dispatch(getUserGeolocation());
    }
  }, [dispatch]);

  return (
    <div className={isForbiddenCountry ? 'with-country-blacklist' : ''}>
      {isForbiddenCountry && <CountryBlacklistRow />}
      { children }
    </div>
  );
};

export default WithCountryBlacklist;
